import axios from "axios";
import { generalActions } from "../actions";
import store from "..";
import {
  ensureFreshToken,
  getStoredRefreshToken,
  handleLogout,
  refreshAccessToken,
} from "../../helpers/tokenManager";
import { handleRateLimitError } from "../../helpers/rateLimitHandler";

axios.interceptors.response.use(
  (response) => {
    // Safety net alongside the proactive scheduler in tokenManager: if the
    // token is close to expiring, kick off a (deduped) background refresh.
    ensureFreshToken().catch(() => {});
    return response;
  },

  async (error) => {
    handleRateLimitError(error);

    const status = error?.response?.status;
    const originalRequest = error?.config;

    if (
      (status === 401 || status === 403) &&
      originalRequest &&
      !originalRequest._retry &&
      getStoredRefreshToken()
    ) {
      originalRequest._retry = true;
      try {
        const newAccessToken = await refreshAccessToken();
        originalRequest.headers = {
          ...originalRequest.headers,
          Authorization: `Bearer ${newAccessToken}`,
        };
        return axios(originalRequest);
      } catch (refreshError) {
        store.dispatch(
          generalActions.showToast({
            title: "Your session has expired. Please login again.",
            type: "error",
          })
        );
        handleLogout();
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

export default axios;
